import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-toast-item',
	templateUrl: 'toast-item.component.html',
	styleUrls: ['toast-item.component.scss'],
})
export class ToastItemComponent implements OnInit {
	@Input() toast;
	toasterClass: string;
	toastTypeNumber: number;
	public imageBasePath: string = IMAGES_BASEPATH;
	@Output() clearHideBoxToast : EventEmitter<any> = new EventEmitter<any>();

	ngOnInit() {
		this.toastTypeNumber = this.toast.toastTypeNumber;
		this.toasterClass = this.toast.class;
	}

	// Close button for hide box toaster
	hideToast() {
		this.clearHideBoxToast.emit();
	}

}